import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';
import React, { useState } from 'react';
import { Formik } from 'formik';

import { ANALYTICS_EVENTS } from '@nandosaus/constants';
import { analytics } from '../../analytics';
import { Box, Flex } from '../grid';
import { Button } from '../button/new';
import { Modal } from '../modal/new';
import { FilterList } from './filter-list';
import { Icon } from '../icons';
import { P, H4, A } from '../typography/new';
import { ModalFloatingHeader } from '../modal/new/modal-header';

const DietaryFilter = () => {
  const { MenuStore, DietaryPreferencesStore } = useRootStore();

  const { allergenLink } = MenuStore;
  const { dietaryPreferencesList } = DietaryPreferencesStore;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSave = values => {
    DietaryPreferencesStore.saveDietaryPreferences(values);
    window.scrollTo(0, 0);
    analytics.track(ANALYTICS_EVENTS.DIETARY_PREFERENCES_UPDATED, {
      dietaryPreferences: DietaryPreferencesStore.dietaryPreferencesList,
    });
    handleCloseModal();
  };

  return (
    <>
      <Box
        display="flex"
        position="relative"
        data-testid="dietary-preferences-button"
        as="button"
        onClick={() => {
          setIsModalOpen(true);
          analytics.track(ANALYTICS_EVENTS.DIETARY_PREFERENCES_OPENED);
        }}
      >
        {/* use dietaryPreferencesList length to show number of active filters */}
        <Flex
          height="18px"
          width="18px"
          position="absolute"
          backgroundColor="red1"
          borderRadius="100%"
          top="-6px"
          right="-11px"
          alignItems="center"
          justifyContent="center"
          display={dietaryPreferencesList.length > 0 ? 'flex' : 'none'}
          zIndex="1"
        >
          <P color="white" style={{ lineHeight: 1 }} variant="extra-small-semi-bold">
            {dietaryPreferencesList.length}
          </P>
        </Flex>
        <Icon name="filter" fill="currentColor" height="32px" width="32px" />
      </Box>
      <Formik initialValues={DietaryPreferencesStore} onSubmit={handleSave} enableReinitialize>
        {({ handleSubmit }) => (
          <Modal
            open={isModalOpen}
            header={<ModalFloatingHeader handleClose={handleCloseModal} />}
            footer={
              <Button variant="primary" widthType="full" size="tall" onClick={handleSubmit}>
                Apply
              </Button>
            }
            hideBottomDecal
            variant="side"
          >
            <Box mt="80px" position="relative">
              <Flex flexDirection="column" minHeight="100%" alignItems="space-between">
                <Flex flexDirection="column" flex="1">
                  {/* Header */}
                  <Flex flexDirection="column" gap="16px" mb="20px">
                    <H4 my="0">Dietary Preferences</H4>
                    <P variant="small">
                      Setting these will hide things you can&apos;t eat from the menu. Some items will have Veg options
                      but need customisation.
                    </P>
                  </Flex>

                  {/* Content */}
                  <Flex flexDirection="column" flex="1" overflowY="auto" mb="20px">
                    <FilterList />

                    <P variant="extra-small" mt="20px" color="grey70">
                      These filters should be only used for dietary preferences, not dietary requirements due to
                      allergens. We can&apos;t guarantee our products are free from allergens as there&apos;s always a
                      risk of allergen traces due to cross-contact. If you have a food allergy, please tell us when
                      ordering and read our full allergen information
                      {allergenLink && (
                        <A
                          href={allergenLink.url}
                          target="_blank"
                          variant="extra-small"
                          onClick={() => analytics.track(ANALYTICS_EVENTS.ALLERGEN_DOCUMENT_VIEWED)}
                        >
                          {' '}
                          here
                        </A>
                      )}
                      .
                    </P>
                  </Flex>
                </Flex>
              </Flex>
            </Box>
          </Modal>
        )}
      </Formik>
    </>
  );
};

const ObservedDietaryFilter = observer(DietaryFilter);
export { ObservedDietaryFilter as DietaryFilter };
